import { render, staticRenderFns } from "./ClientAssignedUsers.vue?vue&type=template&id=0a37a518&"
import script from "./ClientAssignedUsers.vue?vue&type=script&lang=js&"
export * from "./ClientAssignedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VueCardTitle }  from '@/components'
import { VueNoData }  from '@/components'
import { VueUser }  from '@/components'
installComponents(component, {VCard,VCardText,VDivider,VIcon,VNavigationDrawer,VSpacer,VueCardTitle,VueNoData,VueUser})


/* vuetify-loader */
import installIcons from "!../../../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiFileDocumentEdit } from '@mdi/js';
import { mdiStar } from '@mdi/js';
installIcons(component, {mdiFileDocumentEdit,mdiStar})
